import React from "react"
import { useSelector } from "react-redux"

import { MtGroup } from "server/models"
import { StoreType } from "client/store"
import {
    Default,
    UserIcon,
    TableColumn,
} from "client/components"


const Columns = () => {
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "500px",
        },
        {
            field: "creator",
            header: lang.createdBy,
            cellMinWidth: "150px",
            formatter: (group: MtGroup) => {
                if (group.accountId === 1) return <Default />
                return <UserIcon user={userList[group.creator]} size="sm" />
            },
        },
        {
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        },
    ]

    return columns
}
export default Columns
